import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { sectorService } from 'features/settings/topology/api/sector.service';
import * as React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  equipmentService,
  examService,
  laboratoryService,
  macroExamService,
  productService,
  workstationService
} from 'shared/services';
import { operationalUnitService } from 'features/settings/topology/api/operational-unit.service';
import { Option } from 'shared/types/general';
import toast from 'shared/utils/toast';
import { EnhancedDialog } from 'components/enhanced';

interface ProductToCostDialogProps {
  productId: number;
  mode: string;
  setMode: any;
  callback?: any;
}

export const ProductToCostDialog = ({
  productId,
  mode,
  setMode,
  callback
}: ProductToCostDialogProps) => {
  const { t } = useTranslation();

  const [options, setOptions] = React.useState<Option[]>([]);

  useEffect(() => {
    switch (mode) {
      case 'laboratories':
        laboratoryService.getAllBaseInformation().then((res) => {
          setOptions(
            res.map((item) => {
              return {
                id: item.id,
                code: item.description
              };
            })
          );
        });
        break;
      case 'operational_units':
        operationalUnitService.getAllBaseInformation().then((res) => {
          setOptions(
            res.map((item) => {
              return {
                id: item.id,
                code: item.description
              };
            })
          );
        });
        break;
      case 'sectors':
        sectorService.getAllBaseInformation().then((res) => {
          setOptions(
            res.map((item) => {
              return {
                id: item.id,
                code: item.description
              };
            })
          );
        });
        break;
      case 'workstations':
        workstationService.getAllBaseInformation().then((res) => {
          setOptions(
            res.map((item) => {
              return {
                id: item.id,
                code: item.description
              };
            })
          );
        });
        break;
      case 'equipments':
        equipmentService.getAllBaseInformation().then((res) => {
          setOptions(
            res.map((item) => {
              return {
                id: item.id,
                code: item.description
              };
            })
          );
        });
        break;
      case 'exams':
        examService.getAllBaseInformation().then((res) => {
          setOptions(
            res.map((item) => {
              return {
                id: item.id,
                code: item.description
              };
            })
          );
        });
        break;
      case 'macroexams':
        macroExamService.getAllBaseInformation().then(setOptions);
        break;
      default:
        setOptions([]);
    }
  }, [mode]);

  const handleClose = () => {
    setMode('');
  };

  const onSubmit = (values) => {
    switch (mode) {
      case 'exams':
        examService.assignProduct(values['object_id'], productId).then(() => {
          toast.success(t('actions.successfully.associated'));
          handleClose();
          if (callback) callback();
        });
        break;
      default:
        productService.addCostLink(productId, { ...values, model: mode }).then(() => {
          toast.success(t('actions.successfully.cost-associated'));
          handleClose();
          if (callback) callback();
        });
    }
  };

  return (
    <EnhancedDialog
      open={mode.length > 0}
      onClose={handleClose}
      title={'Aggiungi fonte di costo'}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="sm"
      submitButtonProps={{
        type: 'submit',
        form: 'addCostLink'
      }}>
      <EnhancedForm onSubmit={onSubmit} formId="addCostLink" hideControls>
        {options && (
          <IdentityField
            name="object_id"
            component={AutocompleteAdapter}
            options={options}
            label={t('global.cost-source')}
          />
        )}
      </EnhancedForm>
    </EnhancedDialog>
  );
};
